<ng-template #fieldComponent />
<small [id]="id + '-description'" class="form-text" [ngClass]="props.customDescription?.class">
  {{ description | translate : args }}
</small>
